import EditorConditionActionsContainer from './EditorConditionActionsContainer';
import EditorRelatedConditionsContainer from './EditorRelatedConditionsContainer';
import ConditionBox from '../common/ConditionBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorRelatedConditionsGroupContainer = props => {
  const {
    children,
    dataSeleniumInfo,
    onGroupDelete,
    heading,
    condition,
    conditionPath,
    filterFamily
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "fr-editor-related-condition-group",
    children: [/*#__PURE__*/_jsx(EditorConditionActionsContainer, {
      condition: condition,
      conditionPath: conditionPath,
      dataSeleniumInfo: dataSeleniumInfo,
      filterFamily: filterFamily,
      onConditionDelete: onGroupDelete,
      children: /*#__PURE__*/_jsx(ConditionBox, {
        children: heading
      })
    }), /*#__PURE__*/_jsx(EditorRelatedConditionsContainer, {
      children: children
    })]
  });
};
export default EditorRelatedConditionsGroupContainer;